
import { Vue, Component } from 'vue-property-decorator';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';
import { AuthEnum } from '@/services/permission.service';

@Component
export default class RevisionRecordTable extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  AuthEnum = AuthEnum;

  columns = [
    {
      title: '修改属性',
      dataIndex: 'update_desc',
      key: 'update_desc',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'update_desc' },
    },
    {
      title: '操作人ID',
      dataIndex: 'user_id',
      key: 'user_id',
      align: 'center',
      width: '100px',
    },
    {
      title: '操作人姓名',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: '100px',
    },
    {
      title: '提交时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      width: '160px',
    },
    {
      title: '处理状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'status' },

    },
    {
      title: '备注',
      dataIndex: 'audit_remark',
      key: 'audit_remark',
      align: 'center',
      width: '100px',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: '100px',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];
  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  shopId = '';
  created() {
    this.shopId = this.$route.params.id;
    // this.init();
  }
  async init() {
    const { current, pageSize } = this.pagination;
    const pac = {
      shop_id: this.shopId,
      page: current,
      pageSize,
    };
    const data: any = await this.shopService.getUpdataRecordList(
      pac,
    );
    if (data) {
      this.pagination.current = data.page;
      this.pagination.total = data.total;
      this.data = data.list;
    }
  }

  async deleteItem(action: any) {
    this.$confirm({
      title: '提示',
      content: '确定要删除这条记录吗?',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await this.shopService.postUpdateRecordDelete({
          id: action.id,
        });
        if (res) {
          this.$message.success(res);
          this.init();
        }
      },
      onCancel() { },
    });
  }

  async rePushItem(action: any) {
    const res = await this.shopService.postUpdateRecordRePush({ id: action.id });
    if (res) {
      this.$message.success(res);
      this.init();
    }
  }

  async auditResult(action: any) {
    const params = {
      isUpdateDraft: true,
      shopId: this.shopId,
    };
    const res = await this.shopService.postAuditResult(action.work_order_no, params);
    if (res) {
      let text: any;
      text = res.orderStateName;
      if (res.failReasonList && res.failReasonList.length > 0) {
        text = `${text}（${res.failReasonList[0]}）`;
      }
      this.$message.success(text);
      this.init();
    }
  }

  onChangePage(page: number) {
    this.pagination.current = page;
    this.init();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.init();
  }
}
